import styled from 'styled-components';

export const StyledCollapsible = styled.div``;

export const Title = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #6C727F;
  margin: 16px 0;
`;
